import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text, Table } from '@bigcommerce/big-design';

const ShowOtherSuppliersModal = ({ products, suppliers, showOtherSuppliersModal, setShowOtherSuppliersModal, activeSupplier, modalProductId, modalVariantId, modalOptions, modalProductName, modalType, modalAssignment, }) => {
  const tableData = () => {
    let items = [];

    products?.searchedVariantsMetafields[`${modalProductId}/${modalVariantId}`]?.data.forEach((assignment) => {
      if (suppliers?.suppliers?.find(supp => supp.id === assignment?.key.split('Supplier-')[1]) && assignment?.key !== `Supplier-${activeSupplier?.id}`) {
        let values = JSON.parse(assignment?.value);

        items.push({
          supplier: suppliers?.suppliers?.find(supp => supp.id === assignment?.key.split('Supplier-')[1])?.supplier_name,
          price: values.supplier_price,
          sku: values.supplier_sku,
          moq: values.minimum_order
        })
      }

    })

    return items
  }

  return(
    <Modal
      actions={[
        { text: 'Close', onClick: () => setShowOtherSuppliersModal(false) },
      ]}
      closeOnClickOutside={true}
      closeOnEscKey={true}
      header="Other Suppliers"
      isOpen={showOtherSuppliersModal}
      onClose={() => setShowOtherSuppliersModal(false)}
    >
      <H3>Availability</H3>
      <Table
        columns={[
          { header: 'Supplier', hash: 'supplier', render: ({ supplier }) => supplier },
          { header: 'Price', hash: 'price', render: ({ price }) => price },
          { header: 'SKU', hash: 'sku', render: ({ sku }) => sku },
          { header: 'MOQ', hash: 'moq', render: ({ moq }) => moq },
        ]}
        items={tableData()}
        stickyHeader
      />
    </Modal>
  )
}

const mapStateToProps = state => ({
  products: state.products,
  suppliers: state.suppliers,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ShowOtherSuppliersModal);

